import { useState, useEffect } from 'react';
import { useTheme } from '../../../hooks/useTheme';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  const { theme } = useTheme();
  const isLight = theme === 'light';

  useEffect(() => {
    const onScroll = () => {
      const scrollY = window.scrollY ?? window.pageYOffset ?? document.documentElement.scrollTop ?? document.body.scrollTop ?? 0;
      setVisible(scrollY > 400);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('scroll', onScroll);
    };
  }, []);

  const scrollUp = () => {
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch {
      window.scrollTo(0, 0);
    }
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };

  return (
    <button
      onClick={scrollUp}
      aria-label="Volver arriba"
      className={`fixed bottom-28 right-5 z-50 w-12 h-12 flex items-center justify-center rounded-full border transition-all duration-300 cursor-pointer whitespace-nowrap touch-manipulation
        ${visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'}
        ${isLight
          ? 'bg-white border-gray-200 text-navy-900 hover:bg-gray-50 hover:border-gray-300 active:bg-gray-100'
          : 'bg-navy-800 border-navy-600 text-white/70 hover:bg-navy-700 hover:text-white hover:border-navy-500 active:bg-navy-600'
        }
      `}
    >
      <div className="w-5 h-5 flex items-center justify-center">
        <i className="ri-arrow-up-line text-base font-bold"></i>
      </div>
    </button>
  );
}
